import React from 'react';
import { SparklesIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function WorldObjectsConsistencyModal({
  isOpen,
  onClose,
  onContinue,
  onShowWorldObjects,
  missingImageCount,
  totalCount,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50 pointer-events-auto">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full mx-4 p-6 animate-in fade-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-100 rounded-lg">
              <SparklesIcon className="w-6 h-6 text-amber-600" />
            </div>
            <h2 className="text-lg font-semibold text-gray-900">
              Important Objects Missing Images
            </h2>
          </div>
        </div>

        {/* Message */}
        <div className="mb-6">
          <p className="text-gray-700 text-sm mb-3">
            <span className="font-semibold text-amber-600">{missingImageCount} of {totalCount}</span> important world objects don't have reference images yet.
          </p>
          <p className="text-gray-600 text-sm">
            Generating images for important objects will ensure better visual consistency across your book's illustrations.
          </p>
        </div>

        {/* Stats */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-6">
          <p className="text-xs text-blue-900">
            <span className="font-semibold">Note:</span> You can still generate the image without reference images, but consistency will be better with them.
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onShowWorldObjects}
            className="flex-1 px-4 py-2.5 bg-indigo-500 hover:bg-indigo-600 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            <SparklesIcon className="w-4 h-4" />
            View World
          </button>
          <button
            onClick={onContinue}
            className="flex-1 px-4 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-900 font-medium rounded-lg transition-colors"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
